export const initialState = () => ({
  currentDashboard: {
    uuid: null,
    title: "",
    description: "",
    active: true,
    roles: [],
    filters: [],
    tabs: []
  },

  activeTabUuid: null,

  loading: {
    fetching: false,
    saving: false
  }
})

export default {
  ...initialState()
}
